/** @module Classes */ /** typedoc */
class ProofOfRights {
    constructor() {
        this.id = null;
        this.value = null;
        this.contentType = null;
        this.proofType = null;
    }
}
const keysOfProofOfRights = ["id", "value", "contentType", "proofType"];

export { ProofOfRights, keysOfProofOfRights };
